import { Button, DatePicker, message, Modal, Popconfirm, Select, Space, Table } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { strDate2Server } from "../../extensions/convert";
import { fmtDateTimeFull } from "../../extensions/utils";

const vidOptions = [
  { value: 0, label: "Непринятые", },
  { value: 1, label: "За период", },
]

const directOptions = [
  { value: 1, label: "Входящие", },
  { value: -1, label: "Исходящие", },
]

const statusLabels = {
  0: "Новый",
  1: "Принят",
  2: "Удален"
}

const statusOptions = [
  { value: 0, label: "Новый" },
  { value: 1, label: "Принят" },
  { value: 2, label: "Удален" }
]

const renderStatus = (value) => statusLabels[value] || ""

const Packets = () => {
  const [filter, setFilter] = useState({ vid: 0, dateBeg: dayjs(), dateEnd: dayjs(), direction: 1 });
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editStatus, setEditStatus] = useState(0);

  const getData = () => {
    setLoading(true);
    serverFetch(`packet?vid=${filter.vid}&dateBeg=${strDate2Server(filter.dateBeg)}&dateEnd=${strDate2Server(filter.dateEnd)}&direction=${filter.direction}`)
      .then(data => {
        setLoading(false);
        setItems(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, []);

  const handleEditStatus = () => {
    if (selected.length === 0) return message.warning("Выберите пакеты для изменения статуса");
    const firstPacket = items.find(item => item.id === selected[0]);
    if (firstPacket) { setEditStatus(firstPacket.status); setEditModalVisible(true); }
  };

  const handleSaveStatus = () => {
    setLoading(true);
    const promises = selected.map(id => 
      serverFetch(`packet/${id}`, { 
        method: "PUT", 
        bodyData: { status: editStatus, loadDateTime: dayjs().toISOString() } 
      })
    );
    Promise.allSettled(promises)
      .then(results => {
        const succeeded = results.filter(r => r.status === 'fulfilled').length;
        const failed = results.filter(r => r.status === 'rejected').length;
        if (succeeded > 0) message.success(`Обновлено пакетов: ${succeeded}`);
        if (failed > 0) message.error(`Ошибок: ${failed}`);
        setEditModalVisible(false);
        getData();
      });
  };

  const handleDelete = () => {
    setLoading(true);
    const promises = selected.map(id => serverFetch(`packet/${id}`, { method: "DELETE" }));
    Promise.allSettled(promises)
      .then(results => {
        const succeeded = results.filter(r => r.status === 'fulfilled').length;
        const failed = results.filter(r => r.status === 'rejected').length;
        if (succeeded > 0) message.success(`Удалено пакетов: ${succeeded}`);
        if (failed > 0) message.error(`Ошибок: ${failed}`);
        setSelected([]);
        getData();
      });
  };

  const columns = [
    { dataIndex: "id", title: "#", },
    { dataIndex: "companyName", title: "Компания", },
    { dataIndex: "dateTime", title: "Отправлен", render: fmtDateTimeFull},
    { dataIndex: "status", title: "Статус", render: renderStatus},
    { dataIndex: "loadDateTime", title: "Принят", render: fmtDateTimeFull},
    { dataIndex: "recipeDbId", title: "База"}
  ]

  const onFilterChange = value => setFilter({ ...filter, ...value });

  return<div className="page">
    <Space style={{ marginBottom: 16 }}>
      <div>Вид</div>
      <Select options={vidOptions} value={filter.vid} onChange={e => onFilterChange({ vid: e })} style={{width: 150}}/>
      { filter.vid ? <>
        <DatePicker format="DD.MM.YYYY" value={filter.dateBeg} onChange={e => onFilterChange({ dateBeg: e })} allowClear={false} />
        <div>-</div>
        <DatePicker format="DD.MM.YYYY" value={filter.dateEnd} onChange={e => onFilterChange({ dateEnd: e })} allowClear={false} />
      </> : null}
      <Select options={directOptions} value={filter.direction} onChange={e => onFilterChange({ direction: e })} style={{width: 150}}/>
      <Button onClick={getData}>Обновить</Button>
    </Space>
    <Space style={{ marginBottom: 16 }}>
      <Button onClick={handleEditStatus} disabled={selected.length === 0 || loading}>
        Изменить статус {selected.length > 0 && `(${selected.length})`}
      </Button>
      <Popconfirm title="Подтверждение удаления" description={`Вы уверены, что хотите удалить ${selected.length === 1 ? 'этот пакет' : `пакетов: ${selected.length}`}?`}
        onConfirm={handleDelete} okText="Удалить" cancelText="Отмена" disabled={selected.length === 0}>
        <Button danger disabled={selected.length === 0 || loading}>
          Удалить {selected.length > 0 && `(${selected.length})`}
        </Button>
      </Popconfirm>
    </Space>
    <Table
      dataSource={items}
      loading={loading}
      columns={columns}
      pagination={false}
      size="small"
      rowKey="id"
      rowSelection={{ type: 'checkbox', selectedRowKeys: selected, onChange: setSelected }}
      />
    <Modal title={`Изменение статуса ${selected.length === 1 ? 'пакета' : `пакетов (${selected.length})`}`} open={editModalVisible} onOk={handleSaveStatus}
      onCancel={() => setEditModalVisible(false)} okText="Сохранить" cancelText="Отмена" confirmLoading={loading}>
      <div style={{ marginTop: 16 }}>
        <label>Новый статус:</label>
        <Select options={statusOptions} value={editStatus} onChange={setEditStatus} style={{ width: '100%', marginTop: 8 }} />
      </div>
    </Modal>
  </div>
}

export default Packets;